import React, { Component } from 'react';
import { find, get, cloneDeep } from 'lodash';
import { MegadraftPlugin, MegadraftIcons } from 'megadraft';
import ProductManagerModal from './ProductManagerModal';
import { UploaderView } from './ProductManagerModal.styles';
import ContentListing from './ContentListing.js';
import ContentProduct from './ContentProduct.js';

const { BlockContent, CommonBlock } = MegadraftPlugin;

export default class TableBlock extends Component {
  constructor(props) {
    super(props);

    this._handleEdit = this._handleEdit.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onSave = this.onSave.bind(this);

    this.state = {
      isEditing: false,
    };

    this.actions = [
      { key: 'edit', icon: MegadraftIcons.EditIcon, action: this._handleEdit },
      {
        key: 'delete',
        icon: MegadraftIcons.DeleteIcon,
        action: this.props.container.remove,
      },
    ];
  }

  _handleEdit() {
    this.setState({ isEditing: true });
  }

  onModalClose() {
    if (this.state.isEditing) {
      this.setState({ isEditing: false });
    }
  }

  onSave(data) {
    this.setState({ isEditing: false });
    this.props.container.updateData({ ...data });
    this.props.setRefreshingState();
  }

  _sourceRender(source) {
    return (
      <div className="table-manager-block__source-wrapper">
        <p className="table-manager-block__source">{source.productMap}</p>
      </div>
    );
  }

  render() {
    const data = this.props.data || {}; //cloneDeep(this.props.data);
    let product;
    let listing;
    if (data.productType === 'product') {
      product = find(get(this.props, 'blockProps.plugin.products'), {
        id: Number(data.productMap),
      });
    } else if (data.productType === 'listing') {
      listing = find(get(this.props, 'blockProps.plugin.listings'), {
        id: Number(data.productMap),
      });
    }

    return (
      <UploaderView>
        <CommonBlock {...this.props} actions={this.actions}>
          <BlockContent>
            <div
              className="plugin-content"
              style={{
                border: '1px solid #e6e6e6',
                background: '#f8f9fb',
                padding: '28px',
              }}
            >
              {listing ? (
                <ContentListing listing={listing} />
              ) : product ? (
                <ContentProduct product={product} />
              ) : null}
            </div>
          </BlockContent>
        </CommonBlock>

        <ProductManagerModal
          editorState={this.props.editorState}
          contentType={this.props.options.contentType}
          objectId={this.props.options.objectId}
          isOpen={this.state.isEditing}
          onCloseRequest={this.onModalClose}
          onSaveRequest={this.onSave}
          data={cloneDeep(this.props.data)}
        />
      </UploaderView>
    );
  }
}
